import Stack from '@mui/material/Stack'
import { Typography } from '@mui/material/'
import React from 'react'
import { IconButton, SvgIcon } from '@mui/material'
import { ReactComponent as RightArrowIcon } from '../../../../assets/images/arrows/right.svg'
import Link from '@mui/material/Link'
import { Link as RouterLink } from 'react-router-dom'
import { LinkingItem } from '../../Linking.types'

export type LinkedItemsListItemProps<T> = {
    item: LinkingItem<T>
    index: number
    getItemLinkingProps: (item: LinkingItem<T>) => { pathname: string; autoOpenData: object }
}

const Bulletpoint = () => <li style={{ width: 0, fontSize: '14px' }} />

const getStringWithDotOnTheEnd = (str: string = '') => {
    const trimmedStr = str.trim()
    if (!trimmedStr) return ''

    return trimmedStr.endsWith('.') ? trimmedStr : trimmedStr + '.'
}

const LinkedItemsListItem = <T,>({ item, index, getItemLinkingProps }: LinkedItemsListItemProps<T>) => {
    const linkingProps = getItemLinkingProps(item)

    return (
        <Stack direction="column" px={1} py={1.5} gap={1.5} bgcolor="figma.grayscale.tier7" borderRadius="16px">
            <Stack direction="row" alignItems="flex-end" justifyContent="space-between">
                <Stack direction="row" alignItems="flex-end" gap={1.5}>
                    <Typography
                        variant="22x300"
                        color="figma.grayscale.textHier2"
                        width="24px"
                        textAlign="center"
                        flexShrink={0}
                    >
                        {`${index + 1}.`}
                    </Typography>
                    <Typography variant="16x400" mb="3px">
                        {getStringWithDotOnTheEnd(item.name)}
                    </Typography>
                </Stack>
                <IconButton
                    size="small"
                    onClick={() => {}}
                    sx={{
                        cursor: 'pointer',
                    }}
                >
                    <Link
                        component={RouterLink}
                        display="flex"
                        underline="none"
                        color="figma.grayscale.tier3"
                        to={linkingProps}
                    >
                        <SvgIcon
                            component={RightArrowIcon}
                            inheritViewBox
                            fontSize="small"
                            sx={{
                                fontSize: '20px',
                                color: 'figma.primary',
                            }}
                        />
                    </Link>
                </IconButton>
            </Stack>
            {item.children && (
                <Stack direction="column" gap={1} px={3}>
                    {item.children.map((child) => (
                        <Stack direction="row" alignItems="center" gap={1.5}>
                            <Bulletpoint />

                            <Typography variant="14x400" color="figma.grayscale.textHier2">
                                {getStringWithDotOnTheEnd(child.name)}
                            </Typography>
                        </Stack>
                    ))}
                </Stack>
            )}
        </Stack>
    )
}

export default LinkedItemsListItem
